import formatDecimal from './format-decimal';
var prefixExponent;

var formatPrefixAuto = function formatPrefixAuto(a, b) {
  var c = Math.max;
  var e = formatDecimal(a, b);
  var d, f, g, h;
  return e ? (d = e[0], f = e[1], g = f - (prefixExponent = 3 * c(-8, Math.min(8, Math.floor(f / 3)))) + 1, h = d.length, g == h ? d : g > h ? d + Array(g - h + 1).join('0') : 0 < g ? d.slice(0, g) + '.' + d.slice(g) : '0.' + Array(1 - g).join('0') + formatDecimal(a, c(0, b + g - 1))[0]) : a + '';
};

export { prefixExponent };
export default formatPrefixAuto;